import React, { useEffect, useState } from 'react'
import ajax from '../../common/components/ajax.jsx'
import Constants from '../../common/components/constants.jsx'
import {apiAccess} from "./AxiosWrapper";

function Authentication(props) {
    const [auth, setAuth] = useState({
      loggedIn: false,
      userId: '',
      displayName: '',
      role: {}
    });

    const onLoginStatusChange = (loggedIn, userId, displayName, role) => {
        if (!loggedIn) {
          userId = '';
          displayName = '';
          role = {};
        }
        setAuth({
          loggedIn:loggedIn,
          userId:userId,
          displayName:displayName,
          role:role
        });
      };
  
    useEffect(() => {
        ajax.get(
            Constants.URLs.CHECK_LOGGED_IN,
            (successJson) => {
                const data = successJson.data
                if(data.hasOwnProperty('LOGGED_IN') && data.LOGGED_IN){
                    // ログイン済みの時
                    console.log('I have session.', data);
                    // 受け取るオブジェクトの形式は変更予定
                    const loggedIn    = data.hasOwnProperty('LOGGED_IN'   )? data.LOGGED_IN    : false;
                    const userId      = data.hasOwnProperty('USER_ID'     )? data.USER_ID      : '';
                    const displayName = data.hasOwnProperty('DISPLAY_NAME')? data.DISPLAY_NAME : '';
                    const role        = data.hasOwnProperty('ROLE'        )? data.ROLE         : {};
    
                    onLoginStatusChange(loggedIn, userId, displayName, role);
                } else {
                    // ログインされていない時
                    if(document.location.pathname.indexOf('/login') !== 0){
                        document.location.href = '/login';
                    }
                    return;
                }

            },
            (_errorJson) => {
                if(document.location.pathname.indexOf('/login') !== 0){
                    document.location.href = '/login';
                }
                return;
            }
        );
    }, []);

    let hand_auth = {
        loggedIn:    auth.loggedIn,
        userId:      auth.userId,
        displayName: auth.displayName,
        role:        auth.role,
        onLoginStatusChange: (loggedIn, userId, displayName, role) => {
            onLoginStatusChange(loggedIn, userId, displayName, role);
        },
    };
  
    return (
        <div>
            {props.children && React.cloneElement(props.children, {
                auth: hand_auth,
            })}
        </div>
    );
  }
  
  export default Authentication;
